import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Utilities.frontend.types'

@Injectable({ providedIn: 'root' })
export class Utilities_create_alert_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { topic: string, message?: string, username: string, navigate?: { label: string, module_id: string, component_id: string, inputs?: any, dialog_size?: ('Small' | 'Standard' | 'Large' | 'Xlarge') } }): Promise<{ alert_id?: string, reasons?: string[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.topic)) {
      $missingRequiredInParams.push('\'topic\'');
    }
    if (isNil($inParams.username)) {
      $missingRequiredInParams.push('\'username\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

